import {makeChannelOptionHtml} from "./ChannelOptionHtml";

export function makeTripadvisorChannelOptionHtml() {
    const innerHtml = 'Tripadvisor';
    const html = makeChannelOptionHtml(innerHtml, [
        'background: #34E0A1;',
    ]);
    return html;
}
